<template>
  <v-dialog
      v-model="active"
      :max-width="maxWidth"
      :persistent="persistent"
      class="deleteuser"
  >
    <v-card
        rounded="xl"
        elevation="6"
        class="pa-2"
    >
      <v-card-text class="pa-8">
        <!-- ICON -->
        <div class="d-flex justify-center mb-5">
          <div class="delete-icon-wrapper">
            <i class="fa-solid fa-triangle-exclamation"></i>
          </div>
        </div>
        <!-- TITLE -->
        <h2 class="text-h5 font-weight-bold text-center mb-3">
          Account löschen
        </h2>
        <!-- TEXT -->
        <p class="text-medium-emphasis text-center mb-2">
          Möchten Sie Ihr Benutzerkonto wirklich dauerhaft löschen?
        </p>

        <p class="text-medium-emphasis text-center mb-6">
          Diese Aktion kann nicht rückgängig gemacht werden.
        </p>
        <!-- ERROR -->
        <v-alert
            v-if="passwordError"
            class="mb-4"
            density="compact"
            type="error"
            variant="tonal"
        >
          Bitte geben Sie Ihr Passwort ein.
        </v-alert>
        <v-alert
            v-else-if="errorUserDelete"
            class="mb-4"
            density="compact"
            type="error"
            variant="tonal"
        >
          {{ errorUserDelete }}
        </v-alert>
        <!-- PASSWORD -->
        <v-text-field
            v-model="password"
            :rules="[rules.required]"
            autocomplete="current-password"
            color="error"
            density="comfortable"
            label="Passwort bestätigen"
            :type="showPassword ? 'text' : 'password'"
            variant="outlined"
            hide-details
            class="mb-8"
        >
          <template v-slot:append-inner>
            <i
                :class="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"
                style="cursor: pointer"
                @click="showPassword = !showPassword"
            ></i>
          </template>
        </v-text-field>
        <!-- BUTTONS -->
        <v-row>
          <v-col cols="12" md="6">
            <v-btn
                block
                size="large"
                variant="outlined"
                class="delete-btn"
                @click.stop.prevent="submit(false)"
            >
              Abbrechen
            </v-btn>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn
                block
                size="large"
                color="error"
                class="delete-btn"
                :loading="loadingUser"
                @click.stop.prevent="submit(true)"
            >
              <i class="fa-solid fa-trash mr-2"/>
              Account löschen
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: 'ModalConfirm',
  data() {
    return {
      active: false,
      persistent: false,
      maxWidth: 560,
      cancelColor: '',
      cancelTitle: 'Nein',
      confirmColor: 'error',
      confirmTitle: 'Ja',
      password: '',
      passwordError: false,
      rules: {
        required: value => !!value || 'Pflichtfeld.'
      },
      showPassword: false,
    }
  },
  computed: {
    ...mapGetters([
      'errorUserDelete'
    ])
  },
  methods: {
    show(options = {}) {
      if (this.active) {
        this.close();
        this.$nextTick(() => this.show(options));
        return;
      }
      Object.keys(options).forEach(field => this[field] = options[field]);
      this.passwordError = false;
      this.active = true;
    },
    submit(value) {
      if (value) {
        this.passwordError = false;
        if (this.password) {
          this.$store.dispatch('deleteUser', {
            password: this.password
          }).then(response => {
            if (response) {
              this.active = false;
              this.$router.push('/');
            }
          });
        } else {
          this.passwordError = true;
        }
      } else {
        this.active = false;
      }
    }
  }
}
</script>